export default {"src":"/_next/static/media/bean.63b45ad2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};